<div class="flex justify-center items-center" *ngIf="loading">
    <mat-spinner
        class="loading-spinner"
        [color]="color"
        [diameter]="diameter"
    >
    </mat-spinner>
</div>

<div class="grid grid-cols-1 gap-y-2" *ngIf="!loading">
    <h3 class="text-center md:text-left mb-2"><b>Please enter your Lifestyle Rewards details</b></h3>
    <form [formGroup]="loginForm">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-x-4">
            <mat-form-field class="tile" appearance="none">
                <mat-label><strong>Mobile Number</strong></mat-label>
                <input
                    (click)="resetValidation()"
                    matInput
                    placeholder="0821234567"
                    formControlName="mobileNumber"
                    required
                    [errorStateMatcher]="matcher"
                    maxlength="10"
                    type="tel"
                    inputmode="tel"
                >
                <mat-error *ngIf="showErrors">
                    Please enter a valid mobile number (10 digits starting with 0).
                </mat-error>
            </mat-form-field>
            <mat-form-field class="tile" appearance="none">
                <mat-label><strong>PIN</strong></mat-label>
                <input
                    (click)="resetValidation()"
                    matInput
                    [type]="hide ? 'password' : 'text'"
                    required
                    formControlName="pin"
                    [errorStateMatcher]="matcher"
                >
                <mat-error *ngIf="showErrors">
                    Please enter your PIN.
                </mat-error>
                <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide PIN'" [attr.aria-pressed]="hide">
                    <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                </button>
            </mat-form-field>
        </div>
    </form>
    <button class="pay py-3 mt-4 w-full min-w-max md:px-12 text-lg font-semibold tracking-widest continue justify-self-center md:justify-self-end" [ngStyle]="{'background-color':getColorScheme(), 'color':getTextColor()}" mat-raised-button (click)="formValidation()">Pay Now</button>
</div>
